
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="accountablefunctionForm">
    <div class="">
      <h3 class="form_name">AccountableFunction</h3>


        <div class="input">
          <label for="">AccountableFunction Name</label>
          <input type="text" class="default_input reference-form" formControlName="AccountableFunctionName" />
        </div>

        <div class="input">
          <label for="">Functional Email</label>
          <input type="text" class="default_input reference-form" formControlName="FunctionalEmail" />
        </div>

        <div class="input">
          <label for="">Team Lead</label>
          <input type="text" class="default_input reference-form" formControlName="TeamLead" />
        </div>


      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="addNew(accountablefunctionForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null" (click)="addNew(accountablefunctionForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table" >
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for Function"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(functions | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectFunction(option.id)"
                *ngFor="let option of result"
                [value]="option.FunctionName"
              >
                {{ option.FunctionName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">AccountableFunction Name</span>
        <span class="item">Functional Email</span>
        <span class="item">Team Lead</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" *ngIf="status">
      <div class="the_body"
      *ngFor="let accountableFunction of accountablefunctionFormArray.get('AccountableFunctions')['controls']; index as i"
      (click)="onEdit(i, accountableFunction.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{accountableFunction.value.AccountableFunctionName}}</span>
        <span class="content">{{accountableFunction.value.FunctionalEmail}}</span>
        <span class="content">{{accountableFunction.value.TeamLead}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteAccountableFunction(i, accountableFunction.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(accountablefunctionFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
